import { IComponentOptions } from "angular";
import { MachinesMoveViewComponentController } from "./controller";

export const vsComponentName = "machinesMove";

export const machinesMoveViewComponentOptions: IComponentOptions = {
  controller: MachinesMoveViewComponentController,
  controllerAs: "machinesMoveComponentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    machineConfigurations: "<",
  },
};
